module.exports = __webpack_public_path__ + "static/colour-a7722cf6649eb832d457456e59d8beeb.png";